// src/components/PlanCard.js
import React, { useState } from 'react';
import { createSolicitation } from '../services/api';

const PlanCard = ({
  logoTop,
  logoLeft,
  planName,
  itens,
  preco,
  onDetalhesClick,
  planId,
  onSuccess
}) => {
  const [loading, setLoading] = useState(false);

  const handleAssinarPlano = async () => {
    if (loading) return;
    setLoading(true);

    const leadId = parseInt(localStorage.getItem("leadId"), 10);
    const planIdInt = Number(planId);
    if (!leadId || isNaN(planIdInt)) {
      alert("Lead ou Plano inválido. Por favor, crie um lead e selecione um plano.");
      setLoading(false);
      return;
    }

    try {
      await createSolicitation({ id_leads: leadId, id_plans: planIdInt });
      localStorage.clear();
      onSuccess();
    } catch (error) {
      console.error("Erro ao criar solicitação:", error);
      alert("Erro ao criar solicitação. Por favor, tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex-shrink-0 w-[300px] bg-white shadow-lg rounded-lg p-4">
      <img src={logoTop} alt="Logo Topo" className="w-[100px] mx-auto mb-4" />

      <div className="flex justify-center mb-4">
        <img src={logoLeft} alt="Logo Esquerda" className="w-[100px]" />
      </div>

      <p className="bg-black text-white text-sm px-2 py-1 rounded-lg text-center mb-4">
        {planName || "Nome do Plano Indisponível"}
      </p>

      <ul className="text-left mb-4 space-y-1">
        {itens.map((item, i) => (
          <li key={i} className="text-sm text-gray-700">• {item}</li>
        ))}
      </ul>

      <div className="text-center text-lg font-bold text-black mb-4">{preco}/mês</div>

      <div className="space-y-2">
        <button
          onClick={onDetalhesClick}
          className="w-full h-12 bg-[#8F9D8C] text-white text-sm font-bold rounded-md hover:bg-[#576456] transition"
        >
          Mais detalhes
        </button>
        <button
          onClick={handleAssinarPlano}
          disabled={loading}
          className={`w-full h-12 text-sm font-bold rounded-md transition 
            ${loading 
              ? "bg-gray-400 cursor-not-allowed text-white" 
              : "border border-[#2A4DD0] text-[#2A4DD0] bg-white hover:bg-[#F0F4FF]"
            }`}
        >
          {loading ? "Processando..." : "Assinar"}
        </button>
      </div>
    </div>
  );
};

export default PlanCard;
